/* eslint-disable react/no-deprecated */
/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import RootContainer from './containers/root';
import configureStore from './store';
import './assets/styles/main.scss';
import './assets/fontawesome/svg-with-js/js/fontawesome-all.min';

const store = configureStore({});

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <RootContainer />
  </Provider>
);

if (module.hot) {
  module.hot.accept();
}
